module.exports = __webpack_public_path__ + "c2h4static/img/startTest.34705f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/startTest.png
// module id = rWzo
// module chunks = 1